<app-alert-erro [alertErro]="alertErro" [mensagemErro]="mensagemErro"
  (alertErroFechou)="eventoAlertErroFechou($event)">
</app-alert-erro>

<app-alert-sucesso
  [alertSucesso]="alertSucesso"
  [alertSucessoMensagem]="alertSucessoMensagem"
  [alertSucessoSubtitulo]="alertSucessoSubtitulo"
  (alertSucessoFechou)="eventoAlertSucessoFechou($event)">
</app-alert-sucesso>

@if (alertIncluirDepartamento) {
  <div class="body-alert">
    <div class="div-alert text-center">
      <p class="titulo-alert text-start">Inclusão de departamento</p>
      <p class="subtitulo-alert text-start">Inclua um departamento não cadastrado</p>
      <p class="texto-titulo text-start mt-5">NOME DO DEPARTAMENTO</p>
      <div class="row">
        <div class="col-lg-7">
          <div class="mb-4">
            <input
              type="text"
              class="form-control"
              id="inptNomeDepartamento"
              [(ngModel)]="novoDepartamento">
          </div>
        </div>
        <div class="col-lg-2">
          <button
            type="button"
            class="botao-secundario text-center"
            id="btnIncluir"
            (click)="adicionarDepartamentos()">
            INCLUIR
          </button>
        </div>
        <div class="col-lg-1">
          <i
            class="fa fa-info-circle c-black fa-1x mt-2 ms-4 icone-padrao"
            aria-hidden="true"
            [popover]="myPopoverDepartamento"
            popoverTitle="Incluir"
            popoverPlacement="top"
            triggers="click"
            [outsideClick]="true">
          </i>
          <ng-template #myPopoverDepartamento>
            <span class="texto-tabela">
              O botão de incluir permite que você adicione mais de um departamento.
            </span>
          </ng-template>
        </div>
      </div>
      <table class="table table-hover border-bottom mt-4" aria-describedby="tabela que lista departamentos">
        <thead>
          <tr>
            <th scope="col">Departamento</th>
            <th scope="col" class="text-end">Ações</th>
          </tr>
        </thead>
        <tbody>
          @for (lista of listaDepartamento; track lista) {
            <tr>
              <td>{{ lista | uppercase }}</td>
              <td class="text-end">
                <button
                  class="btn-icon"
                  aria-label="Remover item"
                  (click)="clickExclude(lista)"
                  >
                  <i class="fa fa-trash c-primary col-lg-1 icone-menor" aria-hidden="true"></i>
                </button>
              </td>
            </tr>
          }
        </tbody>
      </table>
      <button
        type="button"
        class="botao-outline me-2"
        id="btnCancelarDepartamento"
        (click)="cancelarIncluirDepartamento()">
        CANCELAR
      </button>
      <button
        class="botao mt-3 mb-3"
        id="btnSalvarDepartamento"
        (click)="onSubmit()">
        SALVAR
      </button>
    </div>
  </div>
}